import router from '../router'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default ({
    namespaced: true,


    state: {
        fotoSupervivencia: '',
    }


})